import { PRIVACY_SECTIONS } from '../PrivacyPolicy/PrivacyPolicy.constants';
import { TERMS_SECTIONS } from '../TermsOfService/TermsOfService.constants';
import { REFUND_SECTIONS } from '../RefundReturnPolicy/RefundReturnPolicy.constants';
import { COMPLAINTS_SECTIONS } from '../ComplaintsWarrantyPolicy/ComplaintsWarrantyPolicy.constants';
import { SHIPPING_SECTIONS } from '../ShippingPolicy/ShippingPolicy.constants';

type TPolicyGroup = {
  id: string;
  titleKey: string;
  sectionPrefix: string;
  sections: readonly {
    key: string;
    paragraphs?: readonly string[];
    bullets?: readonly string[];
  }[];
};

export const LEGAL_POLICY_GROUPS: readonly TPolicyGroup[] = [
  {
    id: 'privacy-policy',
    titleKey: 'privacy.policy.page.title',
    sectionPrefix: 'privacy.policy.page.section',
    sections: PRIVACY_SECTIONS,
  },
  {
    id: 'terms-of-service',
    titleKey: 'terms.of.service.page.title',
    sectionPrefix: 'terms.of.service.page.section',
    sections: TERMS_SECTIONS,
  },
  {
    id: 'refund-return-policy',
    titleKey: 'refund.return.policy.page.title',
    sectionPrefix: 'refund.return.policy.page.section',
    sections: REFUND_SECTIONS,
  },
  {
    id: 'complaints-warranty-policy',
    titleKey: 'complaints.warranty.policy.page.title',
    sectionPrefix: 'complaints.warranty.policy.page.section',
    sections: COMPLAINTS_SECTIONS,
  },
  {
    id: 'shipping-policy',
    titleKey: 'shipping.policy.page.title',
    sectionPrefix: 'shipping.policy.page.section',
    sections: SHIPPING_SECTIONS,
  },
] as const;
